
<div class="checkout-section" [ngClass]="{active: active && enabled}">
    <ng-content></ng-content>
</div>
